<template>
  <div class="NewsCenterDetails " style="align-self: center;">
      <!-- 标题 -->
    <div class="flex-all-center mt-76">
      <p class="titletext">
        {{ $t('newsCenterDetails7.text1') }}
      </p>
    </div>
    <!-- 标题下图标 -->
    <div class="timeandaddress flex-all-center">
      <div class="mr-6"><img src="../../assets/images/time_icon.png" class="iconimg "></div>
      <div class="mr-38">{{ $t('newsCenterDetails7.text2') }}</div>
      <div class="mr-6"><img src="../../assets/images/postion_icon.png" class="iconimg"></div>
      <div>{{ $t('newsCenterDetails7.text3') }}</div>
    </div>

    <!-- 正文 -->
    <div class="main">
        <div class="maincontent">
          <p>{{ $t('newsCenterDetails7.text4') }}</p>
          <p>{{ $t('newsCenterDetails7.text5') }}</p>
          <div class="textlayout">
            <img class="picimg1" src="../../assets/images/NewsCenterDetails7_pic1.png" >
            <img class="picimg1" src="../../assets/images/NewsCenterDetails7_pic2.png" >
          </div>
                    <p>{{ $t('newsCenterDetails7.text6') }}</p>
          <div class="textlayout">
            <img class="picimg2" src="../../assets/images/NewsCenterDetails7_pic3.png" >
            <img class="picimg2" src="../../assets/images/NewsCenterDetails7_pic4.png" >
            <img class="picimg2" src="../../assets/images/NewsCenterDetails7_pic5.png" >
            <img class="picimg2" src="../../assets/images/NewsCenterDetails7_pic6.png" >
          </div>
                    <p>{{ $t('newsCenterDetails7.text7') }}</p>
          <div class="textlayout">
            <img class="picimg3" src="../../assets/images/NewsCenterDetails7_pic7.png" >
            <img class="picimg3" src="../../assets/images/NewsCenterDetails7_pic8.png" >
          </div>
                    <p>{{ $t('newsCenterDetails7.text8') }}</p>
          <div class="textlayout">
            <img class="picimg4" src="../../assets/images/NewsCenterDetails7_pic9.png" >
            <img class="picimg4" src="../../assets/images/NewsCenterDetails7_pic10.png" >
          </div>
                    <p>{{ $t('newsCenterDetails7.text9') }}</p>
          <div class="textlayout">
            <img class="picimg5" src="../../assets/images/NewsCenterDetails7_pic11.png" >
          </div>
                    <p>{{ $t('newsCenterDetails7.text10') }}</p>
          <div class="textlayout">
            <img class="picimg6" src="../../assets/images/NewsCenterDetails7_pic12.png" >
            <img class="picimg6" src="../../assets/images/NewsCenterDetails7_pic13.png" >
            <img class="picimg6" src="../../assets/images/NewsCenterDetails7_pic14.png" >
          </div>
          <div class="flex-all-center video-container">
            <img src="../../assets/images/NewsCenterDetails7_videoBackGround.png" alt="" class="background-image">
            <video id="playerId" class="video-js vjs-default-skin video " 
            controls preload="none"
            poster=""
            data-setup="{}">
            <source src="../../assets/videos/NewsCenterDetails7_video.mp4" type='video/mp4' />
            </video>
          </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="footer"></div>
</div>
</template>

<script>
export default {
  name: "newscenterdetails7",
  components: {
    // Tabbar,
  },
  data() {
    return {
    };
  },
  computed: {},
  created() {
    this.getfont();
  },
  methods: {
    // 查询当前根元素字体大小 默认16px
    getfont()
    {
      const fontstyle = window.getComputedStyle(document.documentElement);
      this.rootFontsize = fontstyle.fontSize;
      console.log('字体大小', this.rootFontsize);
    }
  },

};
</script>

<style lang="scss" scoped>
.NewsCenterDetails
{
    color: #000;
    width: 100%;
}

.titletext
{
  font-family: "OPPO-B";
  max-width: 1100px;
  line-height: 60px;
  font-size: 42px;
  text-align: center;
}
.main
{
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.textlayout
{
  display: flex;
  align-items: center;
  justify-content: center;
}

.maincontent
{
  max-width: 990px;
   text-indent: 32px;
   text-align:justify;
   width: 100%;
   line-height: 32px;
   p{
    font-family:"OPPO-R";
    font-size: 16px;
   }
   .maintitie
   {
    text-align: center;
    font-family: "OPPO-B";
    font-size: 28px;
    margin-top: 40px;
    margin-bottom: 40px;
   }
}

.timeandaddress
{
    color: #909399;
    margin-top: 37px;
    font-family: "OPPO-R";
    font-size: 16px;
}

.iconimg
{
    width: 17px;
    height: auto;
    position:relative;
    top: 2px;
}

// 图片
.picimg1
{
    width: 435px;
    height: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    margin-left: 20px;
}
.picimg2
{
    width: 207px;
    height: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    margin-left: 20px;
}
.picimg3
{
    width: 435px;
    height: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    margin-left: 20px;
}
.picimg4
{
    width: 435px;
    height: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    margin-left: 20px;
}
.picimg5
{
    width: 890px;
    height: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    margin-left: 20px;
}
.picimg6
{
    width: 284px;
    height: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    margin-left: 20px;
}
.video-container {
  position: relative;
  width: 100%; /* 根据需要调整 */
  height: 500px; /* 根据需要调整 */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.background-image {
  width: 100%; 
  height: auto; 
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1; 
}
.video {
  position: relative;
  z-index: 2; 
  width: auto; 
  height: 500px; 
}

.footer
{
  margin-top: 120px;
}

@media (max-width: 1024px) {
.titletext
{
  width: 90%;
}
.textlayout
{
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.maincontent
{
   text-indent: 32px;
   font-family: "OPPO-R";
   font-size: 17px;
   line-height: 32px;
   width: 90%;

   p{
    font-family:"OPPO-R";
    font-size: 16px;
    
   }
   .maintitie
   {
    text-align: center;
    font-family: "OPPO-B";
    font-size: 28px;
    margin-top: 40px;
   }
}

.picimg1
{
    width: 90%;
    height: auto;
    margin-top: 29px;
    margin-bottom: 29px;
    margin-left: 0px;
}
.picimg2
{
    width: 90%;
    height: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    margin-left: 20px;
}
.picimg3
{
    width: 90%;
    height: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    margin-left: 20px;
}
.picimg4
{
    width: 90%;
    height: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    margin-left: 20px;
}
.picimg5
{
    width: 90%;
    height: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    margin-left: 20px;
}
.picimg6
{
    width: 90%;
    height: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    margin-left: 20px;
}
.video-container {
  position: relative;
  width: 100%; /* 根据需要调整 */
  height: auto; /* 根据需要调整 */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.background-image {
  width: 100%; 
  height: auto; 
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1; 
}
.video {
  position: relative;
  z-index: 2; 
  width: auto; 
  height: 230px; 
}
.footer
{
  margin-top: 40px;
}
}
</style>